import React from 'react'

class Mail extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
        <path
          fill="#343638"
          fillRule="nonzero"
          d="M1.5 14.5h17V3.176l-8.5 6.99-8.5-6.99V14.5zm17-13.266l.953-.784.547.258v1.234l-1.5 1.234V1.234zM0 1.942V.708L.547.45l.953.784v1.942L0 1.942zM0 0l10 8.224L20 0v16H0V0zm1.5 1.5v13h17v-13h-17zM0 0h20v16H0V0z"
        />
      </svg>
    )
  }
}

export default Mail
